// ** Initial State
const initialState = {
  registrants:null, 
  pageLoader:true,
  yearWiseComparison:null

}

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_REGISTRANTS':
      return { ...state, registrants: action.data }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    case 'GET_YEAR_WISE_COMPARISON':
      return { ...state, yearWiseComparison: action.data }
    default:
      return { ...state }
  }
}
export default dashboard
